/* [04] Signal / Compact concept only — never a cart or checkout interface.
   Only renders with ?signal04=1 (Black) or ?signal04=2 (Moss) on V3. */
(()=>{'use strict';
const params=new URLSearchParams(location.search);
const variant=params.get('signal04');
if(!['1','2'].includes(variant))return;
function render(){
 if(document.querySelector('[data-e04-signal-concept]'))return;
 let container=null,reference=null,place='';
 const room=document.querySelector('[data-event-shop-04] .event-shop-04__inner');
 if(room){
  // Below event introduction, immediately above the featured product.
  container=room;
  reference=room.querySelector('[data-event-hero]');
  place='room';
 }else if(/^\/products\/[^/]+/.test(location.pathname)){
  const details=document.querySelector('#MainContent .product-information[data-testid="product-information"] .product-details');
  if(!details)return;
  // Shopify's .product-details is a flex wrapper beside the gallery.
  // A sibling of .group-block stretches to the gallery height on mobile.
  // Insert INSIDE the real product content stack instead.
  const stack=details.querySelector(':scope > .group-block > .group-block-content');
  if(!stack)return;
  container=stack;
  reference=stack.firstElementChild;
  place='pdp';
 }
 if(!container||!reference)return;
 const el=document.createElement('aside');
 el.className='e04-signal e04-signal--'+(variant==='2'?'moss':'black')+' e04-signal--'+place;
 el.dataset.e04SignalConcept='';
 el.setAttribute('role','note');
 el.setAttribute('aria-label','[04] Signal Bar concept preview, not a live event notification');
 el.innerHTML=
  '<div class="e04-signal__row">'+
    '<span class="e04-signal__mark" aria-hidden="true">[04]</span>'+
    '<span class="e04-signal__message">FIRST COME, FIRST SERVED™</span>'+
    '<span class="e04-signal__state"><i aria-hidden="true"></i>LIVE · DEMO</span>'+
  '</div>'+
  '<div class="e04-signal__caption">'+
    '<span class="e04-signal__tag">SIGNAL / 001<span class="e04-signal__separator" aria-hidden="true">—</span>Buy Early. Pay Less.</span>'+
    '<span class="e04-signal__disclaimer">CONCEPT PREVIEW / NOT A LIVE EVENT</span>'+
  '</div>';
 container.insertBefore(el,reference);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render,{once:true});
else render();
})();